export const manifest = {
  screens: {
    scr_ms7fzn: { name: "1 · From Webinar To Series", route: "/", state: {"slide":0}, position: {"x":160,"y":220} },
    scr_b3fw27: { name: "2 · The Challenge", route: "/", state: {"slide":1}, position: {"x":1560,"y":220} },
    scr_qwbdvu: { name: "3 · Content Funnel", route: "/", state: {"slide":2}, position: {"x":2960,"y":220} },
    scr_n2s40c: { name: "4 · June Webinar Example", route: "/", state: {"slide":3}, position: {"x":4360,"y":220} },
    scr_kreehs: { name: "5 · The Hollywood Model", route: "/", state: {"slide":4}, position: {"x":8560,"y":220} },
    scr_9s7i8p: { name: "6 · What Makes It Different", route: "/", state: {"slide":5}, position: {"x":5760,"y":220} },
    scr_ab4sly: { name: "7 · Expected Impact", route: "/", state: {"slide":6}, position: {"x":7160,"y":220} },
  },
  sections: {
    sec_k9nyik: { name: "Webinar to Series Strategy", x: 0, y: 0, width: 9920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_k9nyik", children: [
      { kind: "screen", id: "scr_ms7fzn" },
      { kind: "screen", id: "scr_b3fw27" },
      { kind: "screen", id: "scr_qwbdvu" },
      { kind: "screen", id: "scr_n2s40c" },
      { kind: "screen", id: "scr_9s7i8p" },
      { kind: "screen", id: "scr_ab4sly" },
      { kind: "screen", id: "scr_kreehs" },
    ] },
  ],
}
